import * as React from 'react';
import * as ReactDOM from 'react-dom';

import App from './components/App';

ReactDOM.render(
  <App/>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./client.tsx